const mistakes = [
  {
    icon: "ri-camera-off-line",
    title: "Non-Compliant Passport Photo",
    description: "Idaho Falls applicants often use photos taken at home with wrong background or lighting. State Department photo standards are strict — we guide you to the right vendor.",
  },
  {
    icon: "ri-file-damage-line",
    title: "Incorrect Form Version",
    description: "Using an outdated DS-11 or DS-82 form is an instant rejection. We always use the current approved version.",
  },
  {
    icon: "ri-bank-card-line",
    title: "Forgetting Government Fee Check",
    description: "The government fee must be a separate check or money order payable to 'U.S. Department of State.' We remind you of every payment requirement.",
  },
  {
    icon: "ri-pen-nib-line",
    title: "Signing Before the Agent",
    description: "DS-11 forms must be signed in front of the acceptance facility agent — not before. A pre-signed form means automatic rejection.",
  },
  {
    icon: "ri-parent-line",
    title: "Missing Parental Consent for Minors",
    description: "Both parents must appear for children under 16, or provide notarized DS-3053 consent. We guide Idaho Falls families through every option.",
  },
  {
    icon: "ri-calendar-close-line",
    title: "Underestimating Processing Time",
    description: "Post office expedited processing can take 3–5 weeks. Idaho Falls travelers with imminent travel dates need our 2–9 day courier service.",
  },
];

export default function MistakesSection() {
  return (
    <section id="mistakes" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            6 Mistakes Idaho Falls Applicants Make (And How to Avoid Them)
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            A single mistake can delay your passport by weeks. Our dedicated agents catch every error before submission.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((m, i) => (
            <div key={i} className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 mb-3">
                <i className={`${m.icon} text-red-500`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-2">{m.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}